import React from 'react';
import {Radio} from 'antd';
import commonRefHOC from '../../commonRefHOC';

const RadioButton = Radio.Button;
export default commonRefHOC(RadioButton);